import { formatPhoneNumber } from "Util/formatPhoneNumber";

export const formatOrderCustomerContact = <T extends Record<string, any> | undefined>(
  customer: T
) => ({
  ...customer,
  phone: formatPhoneNumber(customer?.phone),
  mobile: formatPhoneNumber(customer?.mobile),
  destinationMobile: formatPhoneNumber(customer?.destinationMobile),
});
